import React, { useState, useEffect, useContext } from 'react';
import toast, { Toaster } from 'react-hot-toast';
import Col from 'react-bootstrap/Col';
import Form from 'react-bootstrap/Form';
import Row from 'react-bootstrap/Row';
import { Switch, Collapse, Button } from 'antd';


import Loader from '../../components/loader/loader';
import Select from 'react-select';
import AsyncSelect from 'react-select/async';

import { DataContext } from '../../init/getData';

const { Panel } = Collapse;

function LinkAccount() {

  const { api, userData, settingData, auxAccountData, refData, currencyData, selectedCompany, parentAccountData } = useContext(DataContext);
  const userId = userData.id;
  const userName = userData.name;
  const userRole = userData.role.name;
  const companyId = selectedCompany.id;

  const [loadingEffect, setLoadingEffect] = useState(false);
  const [isLoading, setIsLoading] = useState(true);

  const [setting, setSetting] = useState([]);

  useEffect(() => {
    const fetchData = async () => {
      try {
        const dataArray = ['auxAccount', 'currency', 'setting', 'parentAccount']
        await refData(dataArray, companyId);
        setIsLoading(false);
      } catch (error) {
        console.error('Error refreshing data Contact Support');
      }
    };
    fetchData();
  }, []);


  useEffect(() => {
    setSetting({

      //sales
      salesOfGoodsAccountId: settingData.salesOfGoodsAccountId,
      salesOfFinishedProductsAccountId: settingData.salesOfFinishedProductsAccountId,
      salesOfServiceAccountId: settingData.salesOfServiceAccountId,
      salesOfRawMaterialAccountId: settingData.salesOfRawMaterialAccountId,

      //Accounts
      customerAccountId: settingData.customerAccountId,
      supplierAccountId: settingData.supplierAccountId,
      employeeAccountId: settingData.employeeAccountId,
      expenseAccountId: settingData.expenseAccountId,
      expenseSupplierAccountId: settingData.expenseSupplierAccountId,
      salaryAccountId: settingData.salaryAccountId,
      cashAccountId: settingData.cashAccountId,
      varianceAccountId: settingData.varianceAccountId,

      //Cost 
      cogsAccountId: settingData.cogsAccountId,

      //Purchase 
      purchaseAccountId: settingData.purchaseAccountId,

      //Charges 
      purchaseChargesAccountId: settingData.purchaseChargesAccountId,
      salesChargesAccountId: settingData.salesChargesAccountId,

      //Discount
      purchaseDiscountAccountId: settingData.purchaseDiscountAccountId,
      salesDiscountAccountId: settingData.salesDiscountAccountId,

      //VAT
      vatPurchaseAccountId: settingData.vatPurchaseAccountId,
      vatSalesAccountId: settingData.vatSalesAccountId,
      vatExpenseAccountId: settingData.vatExpenseAccountId,
      vatAssetAccountId: settingData.vatAssetAccountId,

      // Stock
      stockOfGoodsForSaleAccountId: settingData.stockOfGoodsForSaleAccountId,
      stockOfGoodsInProgressAccountId: settingData.stockOfGoodsInProgressAccountId,
      stockOfRawMaterialsAccountId: settingData.stockOfRawMaterialsAccountId,
      stockOfManufacturedProductsAccountId: settingData.stockOfManufacturedProductsAccountId,

      stockVariationOfGoodsForSaleAccountId: settingData.stockVariationOfGoodsForSaleAccountId,
      stockVariationOfRawMaterialsAccountId: settingData.stockVariationOfRawMaterialsAccountId,
      stockVariationOfGoodsInProgressAccountId: settingData.stockVariationOfGoodsInProgressAccountId,
      stockVariationOfManufacturedProductsAccountId: settingData.stockVariationOfManufacturedProductsAccountId,

      openingStockAccountId: settingData.openingStockAccountId,
      stockControlAccountId: settingData.stockControlAccountId,
      stockTransferAccountId: settingData.stockTransferAccountId,

    })
  }, [isLoading]);


  // Account Options
  const accountOptions = auxAccountData?.map(item => ({
    value: item.id,
    label: (item?.parent?.accountId ? item?.parent?.accountId + '.' : '') + item.accountId + ' ' + item.english,
  }));
  const loadAccountOptions = (inpuVatlue, callback) => {
    const filteredOptions = inpuVatlue ? accountOptions.filter(option =>
      option.label.toLowerCase().includes(inpuVatlue.toLowerCase())) : [];
    callback(filteredOptions);
  };

  // Account Options
  const parentOptions = parentAccountData?.map(item => ({
    value: item.id,
    label: `${item.accountId} ${item.english}`,
  }));    
  const loadParentOptions = (inputValue, callback) => {
    const filteredOptions = inputValue ? parentOptions.filter(option =>
      option.label.toLowerCase().includes(inputValue.toLowerCase())) : [];

    callback(filteredOptions);
  };



  const handleSubmit = async () => {

    setLoadingEffect(true);

    const data = {
      setting,
      companyId,
    }


    let res = await api.post(`/setting/edit`, data)
    if (res.data.status) {
      toast.success(res.data.message);
      const dataArray = ['setting']
      await refData(dataArray, companyId);
    }
    else {
      toast.error(res.data.message);
    }
    setLoadingEffect(false);
  }

  const handleInputChange = (e, name) => {
    const value = e.value;
    setSetting((prev) => ({
      ...prev,
      [name]: value,
    }));
  };


  const salesForm = (
    <>
      <Row className="mb-3" style={{ marginTop: '-10px' }}>
        <Form.Label column sm={2}>
          Sales Of Goods
        </Form.Label>
        <Form.Group as={Col} xs={4}>
          <AsyncSelect
            cacheOptions
            loadOptions={loadAccountOptions}
            onChange={(e) => handleInputChange(e, 'salesOfGoodsAccountId')}
            value={accountOptions.find(option => option.value === setting.salesOfGoodsAccountId) || []}
            noOptionsMessage={() => 'type to view'}
            required
          />
        </Form.Group>
      </Row>

      <Row className="mb-3" style={{ marginTop: '-10px' }}>
        <Form.Label column sm={2}>
          Sales Of Finished Products
        </Form.Label>
        <Form.Group as={Col} xs={4}>
          <AsyncSelect
            cacheOptions
            loadOptions={loadAccountOptions}
            onChange={(e) => handleInputChange(e, 'salesOfFinishedProductsAccountId')}
            value={accountOptions.find(option => option.value === setting.salesOfFinishedProductsAccountId) || []}
            noOptionsMessage={() => 'type to view'}
            required
          />
        </Form.Group>
      </Row>

      <Row className="mb-3" style={{ marginTop: '-10px' }}>
        <Form.Label column sm={2}>
          Sales Of RawMaterial
        </Form.Label>
        <Form.Group as={Col} xs={4}>
          <AsyncSelect
            cacheOptions
            loadOptions={loadAccountOptions}
            onChange={(e) => handleInputChange(e, 'salesOfRawMaterialAccountId')}
            value={accountOptions.find(option => option.value === setting.salesOfRawMaterialAccountId) || []}
            noOptionsMessage={() => 'type to view'}
            required
          />
        </Form.Group>
      </Row>

      <Row className="mb-3" style={{ marginTop: '-10px' }}>
        <Form.Label column sm={2}>
          Sales Of Service
        </Form.Label>
        <Form.Group as={Col} xs={4}>
          <AsyncSelect
            cacheOptions
            loadOptions={loadAccountOptions}
            onChange={(e) => handleInputChange(e, 'salesOfServiceAccountId')}
            value={accountOptions.find(option => option.value === setting.salesOfServiceAccountId) || []}
            noOptionsMessage={() => 'type to view'}
            required
          />
        </Form.Group>
      </Row>
    </>
  )

  const purchaseForm = (
    <>
      <Row className="mb-3" style={{ marginTop: '-10px' }}>
        <Form.Label column sm={2}>
          Purchase
        </Form.Label>
        <Form.Group as={Col} xs={4}>
          <AsyncSelect
            cacheOptions
            loadOptions={loadAccountOptions}
            onChange={(e) => handleInputChange(e, 'purchaseAccountId')}
            value={accountOptions.find(option => option.value === setting.purchaseAccountId) || []}
            noOptionsMessage={() => 'type to view'}
            required
          />
        </Form.Group>
      </Row>
    </>
  )

  const accountsForm = (
    <>
      <Row className="mb-3" style={{ marginTop: '-10px' }}>
        <Form.Label column sm={2}>
          Customer Account
        </Form.Label>
        <Form.Group as={Col} xs={4}>
          <AsyncSelect
            cacheOptions
            loadOptions={loadParentOptions}
            onChange={(e) => handleInputChange(e, 'customerAccountId')}
            value={parentOptions.find(option => option.value === setting.customerAccountId) || []}
            noOptionsMessage={() => 'type to view'}
            required
          />
        </Form.Group>
      </Row>

      <Row className="mb-3" style={{ marginTop: '-10px' }}>
        <Form.Label column sm={2}>
          Supplier Account
        </Form.Label>
        <Form.Group as={Col} xs={4}>
          <AsyncSelect
            cacheOptions
            loadOptions={loadParentOptions}
            onChange={(e) => handleInputChange(e, 'supplierAccountId')}
            value={parentOptions.find(option => option.value === setting.supplierAccountId) || []}
            noOptionsMessage={() => 'type to view'}
            required
          />
        </Form.Group>
      </Row>

      <Row className="mb-3" style={{ marginTop: '-10px' }}>
        <Form.Label column sm={2}>
          Employee Account
        </Form.Label>
        <Form.Group as={Col} xs={4}>
          <AsyncSelect
            cacheOptions
            loadOptions={loadParentOptions}
            onChange={(e) => handleInputChange(e, 'employeeAccountId')}
            value={parentOptions.find(option => option.value === setting.employeeAccountId) || []}
            noOptionsMessage={() => 'type to view'}
            required
          />
        </Form.Group>
      </Row>

      <Row className="mb-3" style={{ marginTop: '-10px' }}>
        <Form.Label column sm={2}>
          Expense Account
        </Form.Label>
        <Form.Group as={Col} xs={4}>
          <AsyncSelect
            cacheOptions
            loadOptions={loadParentOptions}
            onChange={(e) => handleInputChange(e, 'expenseAccountId')}
            value={parentOptions.find(option => option.value === setting.expenseAccountId) || []}
            noOptionsMessage={() => 'type to view'}
            required
          />
        </Form.Group>
      </Row>


      <Row className="mb-3" style={{ marginTop: '-10px' }}>
        <Form.Label column sm={2}>
          Expense Supplier
        </Form.Label>
        <Form.Group as={Col} xs={4}>
          <AsyncSelect
            cacheOptions
            loadOptions={loadParentOptions}
            onChange={(e) => handleInputChange(e, 'expenseSupplierAccountId')}
            value={parentOptions.find(option => option.value === setting.expenseSupplierAccountId) || []}
            noOptionsMessage={() => 'type to view'}
            required
          />
        </Form.Group>
      </Row>


      <Row className="mb-3" style={{ marginTop: '-10px' }}>
        <Form.Label column sm={2}>
          Cash Account
        </Form.Label>
        <Form.Group as={Col} xs={4}>
          <AsyncSelect
            cacheOptions
            loadOptions={loadParentOptions}
            onChange={(e) => handleInputChange(e, 'cashAccountId')}
            value={parentOptions.find(option => option.value === setting.cashAccountId) || []}
            noOptionsMessage={() => 'type to view'}
            required
          />
        </Form.Group>
      </Row>


      <Row className="mb-3" style={{ marginTop: '-10px' }}>
        <Form.Label column sm={2}>
          Variance Account
        </Form.Label>
        <Form.Group as={Col} xs={4}>
          <AsyncSelect
            cacheOptions
            loadOptions={loadParentOptions}
            onChange={(e) => handleInputChange(e, 'varianceAccountId')}
            value={parentOptions.find(option => option.value === setting.varianceAccountId) || []}
            noOptionsMessage={() => 'type to view'}
            required
          />
        </Form.Group>
      </Row>


    </>
  )

  const costProfitForm = (
    <>
      <Row className="mb-3" style={{ marginTop: '-10px' }}>
        <Form.Label column sm={2}>
          Cost of goods sold
        </Form.Label>
        <Form.Group as={Col} xs={4}>
          <AsyncSelect
            cacheOptions
            loadOptions={loadAccountOptions}
            onChange={(e) => handleInputChange(e, 'cogsAccountId')}
            value={accountOptions.find(option => option.value === setting.cogsAccountId) || []}
            noOptionsMessage={() => 'type to view'}
            required
          />
        </Form.Group>
      </Row>
    </>
  )


  const discountForm = (
    <>
      <Row className="mb-3" style={{ marginTop: '-10px' }}>
        <Form.Label column sm={2}>
          Purchase Invoice Discount
        </Form.Label>
        <Form.Group as={Col} xs={4}>
          <AsyncSelect
            cacheOptions
            loadOptions={loadAccountOptions}
            onChange={(e) => handleInputChange(e, 'purchaseDiscountAccountId')}
            value={accountOptions.find(option => option.value === setting.purchaseDiscountAccountId) || []}
            noOptionsMessage={() => 'type to view'}
            required
          />
        </Form.Group>
      </Row>

      <Row className="mb-3" style={{ marginTop: '-10px' }}>
        <Form.Label column sm={2}>
          Sales Invoice Discount
        </Form.Label>
        <Form.Group as={Col} xs={4}>
          <AsyncSelect
            cacheOptions
            loadOptions={loadAccountOptions}
            onChange={(e) => handleInputChange(e, 'salesDiscountAccountId')}
            value={accountOptions.find(option => option.value === setting.salesDiscountAccountId) || []}
            noOptionsMessage={() => 'type to view'}
            required
          />
        </Form.Group>
      </Row>
    </>
  )

  const VatForm = (
    <>
      <Row className="mb-3" style={{ marginTop: '-10px' }}>
        <Form.Label column sm={2}>
          VAT Purchase Account
        </Form.Label>
        <Form.Group as={Col} xs={4}>
          <AsyncSelect
            cacheOptions
            loadOptions={loadAccountOptions}
            onChange={(e) => handleInputChange(e, 'vatPurchaseAccountId')}
            value={accountOptions.find(option => option.value === setting.vatPurchaseAccountId) || []}
            noOptionsMessage={() => 'type to view'}
            required
          />
        </Form.Group>
      </Row>


      <Row className="mb-3" style={{ marginTop: '-10px' }}>
        <Form.Label column sm={2}>
          VAT Sales Account
        </Form.Label>
        <Form.Group as={Col} xs={4}>
          <AsyncSelect
            cacheOptions
            loadOptions={loadAccountOptions}
            onChange={(e) => handleInputChange(e, 'vatSalesAccountId')}
            value={accountOptions.find(option => option.value === setting.vatSalesAccountId) || []}
            noOptionsMessage={() => 'type to view'}
            required
          />
        </Form.Group>
      </Row>


      <Row className="mb-3" style={{ marginTop: '-10px' }}>
        <Form.Label column sm={2}>
          VAT Expenses Account
        </Form.Label>
        <Form.Group as={Col} xs={4}>
          <AsyncSelect
            cacheOptions
            loadOptions={loadAccountOptions}
            onChange={(e) => handleInputChange(e, 'vatExpenseAccountId')}
            value={accountOptions.find(option => option.value === setting.vatExpenseAccountId) || []}
            noOptionsMessage={() => 'type to view'}
            required
          />
        </Form.Group>
      </Row>


      <Row className="mb-3" style={{ marginTop: '-10px' }}>
        <Form.Label column sm={2}>
          VAT Assets Account
        </Form.Label>
        <Form.Group as={Col} xs={4}>
          <AsyncSelect
            cacheOptions
            loadOptions={loadAccountOptions}
            onChange={(e) => handleInputChange(e, 'vatAssetAccountId')}
            value={accountOptions.find(option => option.value === setting.vatAssetAccountId) || []}
            noOptionsMessage={() => 'type to view'}
            required
          />
        </Form.Group>
      </Row>
    </>
  )


  const stockForm = (
    <>
      <Row className="mb-3" style={{ marginTop: '-10px' }}>
        <Form.Label column sm={2}>
          Goods For Sale
        </Form.Label>
        <Form.Group as={Col} xs={4}>
          <AsyncSelect
            cacheOptions
            loadOptions={loadAccountOptions}
            onChange={(e) => handleInputChange(e, 'stockOfGoodsForSaleAccountId')}
            value={accountOptions.find(option => option.value === setting.stockOfGoodsForSaleAccountId) || []}
            noOptionsMessage={() => 'type to view'}
            required
          />
        </Form.Group>
      </Row>

      <Row className="mb-3" style={{ marginTop: '-10px' }}>
        <Form.Label column sm={2}>
          Goods In Progres
        </Form.Label>
        <Form.Group as={Col} xs={4}>
          <AsyncSelect
            cacheOptions
            loadOptions={loadAccountOptions}
            onChange={(e) => handleInputChange(e, 'stockOfGoodsInProgressAccountId')}
            value={accountOptions.find(option => option.value === setting.stockOfGoodsInProgressAccountId) || []}
            noOptionsMessage={() => 'type to view'}
            required
          />
        </Form.Group>
      </Row>


      <Row className="mb-3" style={{ marginTop: '-10px' }}>
        <Form.Label column sm={2}>
          Raw Materials
        </Form.Label>
        <Form.Group as={Col} xs={4}>
          <AsyncSelect
            cacheOptions
            loadOptions={loadAccountOptions}
            onChange={(e) => handleInputChange(e, 'stockOfRawMaterialsAccountId')}
            value={accountOptions.find(option => option.value === setting.stockOfRawMaterialsAccountId) || []}
            noOptionsMessage={() => 'type to view'}
            required
          />
        </Form.Group>
      </Row>


      <Row className="mb-3" style={{ marginTop: '-10px' }}>
        <Form.Label column sm={2}>
          Manufactured Products
        </Form.Label>
        <Form.Group as={Col} xs={4}>
          <AsyncSelect
            cacheOptions
            loadOptions={loadAccountOptions}
            onChange={(e) => handleInputChange(e, 'stockOfManufacturedProductsAccountId')}
            value={accountOptions.find(option => option.value === setting.stockOfManufacturedProductsAccountId) || []}
            noOptionsMessage={() => 'type to view'}
            required
          />
        </Form.Group>
      </Row>

      <Row className="mb-3" style={{ marginTop: '-10px' }}>
        <Form.Label column sm={2}>
          Variation Of Goods
        </Form.Label>
        <Form.Group as={Col} xs={4}>
          <AsyncSelect
            cacheOptions
            loadOptions={loadAccountOptions}
            onChange={(e) => handleInputChange(e, 'stockVariationOfGoodsForSaleAccountId')}
            value={accountOptions.find(option => option.value === setting.stockVariationOfGoodsForSaleAccountId) || []}
            noOptionsMessage={() => 'type to view'}
            required
          />
        </Form.Group>
      </Row>

      <Row className="mb-3" style={{ marginTop: '-10px' }}>
        <Form.Label column sm={2}>
          Variation Of RawMaterial
        </Form.Label>
        <Form.Group as={Col} xs={4}>
          <AsyncSelect
            cacheOptions
            loadOptions={loadAccountOptions}
            onChange={(e) => handleInputChange(e, 'stockVariationOfRawMaterialsAccountId')}
            value={accountOptions.find(option => option.value === setting.stockVariationOfRawMaterialsAccountId) || []}
            noOptionsMessage={() => 'type to view'}
            required
          />
        </Form.Group>
      </Row>

      <Row className="mb-3" style={{ marginTop: '-10px' }}>
        <Form.Label column sm={2}>
          Variation Of Goods In Progress
        </Form.Label>
        <Form.Group as={Col} xs={4}>
          <AsyncSelect
            cacheOptions
            loadOptions={loadAccountOptions}
            onChange={(e) => handleInputChange(e, 'stockVariationOfGoodsInProgressAccountId')}
            value={accountOptions.find(option => option.value === setting.stockVariationOfGoodsInProgressAccountId) || []}
            noOptionsMessage={() => 'type to view'}
            required
          />
        </Form.Group>
      </Row>


      <Row className="mb-3" style={{ marginTop: '-10px' }}>
        <Form.Label column sm={2}>
          Variation Of Manufactured Products
        </Form.Label>
        <Form.Group as={Col} xs={4}>
          <AsyncSelect
            cacheOptions
            loadOptions={loadAccountOptions}
            onChange={(e) => handleInputChange(e, 'stockVariationOfManufacturedProductsAccountId')}
            value={accountOptions.find(option => option.value === setting.stockVariationOfManufacturedProductsAccountId) || []}
            noOptionsMessage={() => 'type to view'}
            required
          />
        </Form.Group>
      </Row>


      <Row className="mb-3" style={{ marginTop: '-10px' }}>
        <Form.Label column sm={2}>
          Opening Stock
        </Form.Label>
        <Form.Group as={Col} xs={4}>
          <AsyncSelect
            cacheOptions
            loadOptions={loadAccountOptions}
            onChange={(e) => handleInputChange(e, 'openingStockAccountId')}
            value={accountOptions.find(option => option.value === setting.openingStockAccountId) || []}
            noOptionsMessage={() => 'type to view'}
            required
          />
        </Form.Group>
      </Row>

      <Row className="mb-3" style={{ marginTop: '-10px' }}>
        <Form.Label column sm={2}>
          Stock Control
        </Form.Label>
        <Form.Group as={Col} xs={4}>
          <AsyncSelect
            cacheOptions
            loadOptions={loadAccountOptions}
            onChange={(e) => handleInputChange(e, 'stockControlAccountId')}
            value={accountOptions.find(option => option.value === setting.stockControlAccountId) || []}
            noOptionsMessage={() => 'type to view'}
            required
          />
        </Form.Group>
      </Row>

      <Row className="mb-3" style={{ marginTop: '-10px' }}>
        <Form.Label column sm={2}>
          Stock Transfer
        </Form.Label>
        <Form.Group as={Col} xs={4}>
          <AsyncSelect
            cacheOptions
            loadOptions={loadAccountOptions}
            onChange={(e) => handleInputChange(e, 'stockTransferAccountId')}
            value={accountOptions.find(option => option.value === setting.stockTransferAccountId) || []}
            noOptionsMessage={() => 'type to view'}
            required
          />
        </Form.Group>
      </Row>

    </>
  )

  const chargesForm = (
    <>
      <Row className="mb-3" style={{ marginTop: '-10px' }}>
        <Form.Label column sm={2}>
          Purchase Charges
        </Form.Label>
        <Form.Group as={Col} xs={4}>
          <AsyncSelect
            cacheOptions
            loadOptions={loadAccountOptions}
            onChange={(e) => handleInputChange(e, 'purchaseChargesAccountId')}
            value={accountOptions.find(option => option.value === setting.purchaseChargesAccountId) || []}
            noOptionsMessage={() => 'type to view'}
            required
          />
        </Form.Group>
      </Row>

      <Row className="mb-3" style={{ marginTop: '-10px' }}>
        <Form.Label column sm={2}>
          Sales Charges
        </Form.Label>
        <Form.Group as={Col} xs={4}>
          <AsyncSelect
            cacheOptions
            loadOptions={loadAccountOptions}
            onChange={(e) => handleInputChange(e, 'salesChargesAccountId')}
            value={accountOptions.find(option => option.value === setting.salesChargesAccountId) || []}
            noOptionsMessage={() => 'type to view'}
            required
          />
        </Form.Group>
      </Row>


    </>
  )

  const payRollForm = (
    <>
      <Row className="mb-3" style={{ marginTop: '-10px' }}>
        <Form.Label column sm={2}>
          Salary
        </Form.Label>
        <Form.Group as={Col} xs={4}>
          <AsyncSelect
            cacheOptions
            loadOptions={loadAccountOptions}
            onChange={(e) => handleInputChange(e, 'salaryAccountId')}
            value={accountOptions.find(option => option.value === setting.salaryAccountId) || []}
            noOptionsMessage={() => 'type to view'}
            required
          />
        </Form.Group>
      </Row>
    </>
  )



  const items = [
    {
      key: '1',
      label: 'Sales Revenue',
      children: <>{salesForm}</>,
    },
    {
      key: '2',
      label: 'Account Creation',
      children: <>{accountsForm}</>,
    },
    {
      key: '3',
      label: 'Discount',
      children: <>{discountForm}</>,
    },
    {
      key: '4',
      label: 'VAT',
      children: <>{VatForm}</>,
    },
    {
      key: '5',
      label: 'Stock',
      children: <>{stockForm}</>,
    },
    {
      key: '6',
      label: 'Cost and Profit',
      children: <>{costProfitForm}</>,
    },
    {
      key: '7',
      label: 'Charges',
      children: <>{chargesForm}</>,
    },
    {
      key: '8',
      label: 'Purchase',
      children: <>{purchaseForm}</>,
    },
    {
      key: '9',
      label: 'PayRoll',
      children: <>{payRollForm}</>,
    },
  ];


  return (
    <div>

      {isLoading &&
        <Loader />
      }


      {!isLoading &&
        <div style={{ userSelect: 'none', height: '86vh', display: 'flex', flexDirection: 'row', overflowY: 'scroll' }} >

          <Collapse className="custom-collapse" style={{ width: '100%' }}>
            {items.map(item => (
              <Panel header={item.label} key={item.key}>
                {item.children}
              </Panel>
            ))}
          </Collapse>

          <Button type="primary" size="large" loading={loadingEffect} onClick={handleSubmit}

            style={{ marginLeft: '10px', backgroundColor: '#1d7790' }}>Save</Button>


        </div>
      }
    </div>
  );
}

export default LinkAccount;
